import Cookies from 'js-cookie';

const COOKIE_OPTIONS = {
  expires: 7, // 7 days
  secure: typeof window !== 'undefined' && window.location.protocol === 'https:',
  sameSite: 'strict',
};

const USER_DETAILS_KEY = '@userDetails';

const cookieHelper = {
  // Generic methods
  set(name, value, options = {}) {
    Cookies.set(name, value, {
      ...COOKIE_OPTIONS,
      ...options,
    });
  },

  get(name) {
    return Cookies.get(name);
  },

  remove(name, options = {}) {
    Cookies.remove(name, {
      ...COOKIE_OPTIONS,
      ...options,
    });
  },

  // Auth Token
  setToken(token) {
    cookieHelper.set('id_token', token);
  },

  getToken() {
    return cookieHelper.get('id_token') || null;
  },

  clearToken() {
    cookieHelper.remove('id_token');
  },

  // User Details
  setUserDetails(userDetails) {
    if (!userDetails) return;

    cookieHelper.set(USER_DETAILS_KEY, JSON.stringify(userDetails));
  },

  getUserDetails() {
    const value = cookieHelper.get(USER_DETAILS_KEY);

    if (!value) return null;

    try {
      return JSON.parse(value);
    } catch (error) {
      console.error('Failed to parse user details cookie:', error);
      return null;
    }
  },

  clearUserDetails() {
    cookieHelper.remove(USER_DETAILS_KEY);
  },
};

export default cookieHelper;